"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _lab = require("@material-ui/lab");

var _styles = require("@material-ui/core/styles");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Close = _interopRequireDefault(require("../../assets/img/Close"));

var _Chevron = _interopRequireDefault(require("../../assets/img/Chevron"));

var _constants = require("../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const useStyles = (0, _styles.makeStyles)(() => ({
  autocomplete: {
    marginTop: 10,
    minWidth: 120
  }
}));
const Label = _styledComponents.default.label`
	display: block;
	font-weight: bold;
`;
const AutocompleteIcon = _styledComponents.default.img.attrs(props => ({
  width: '24px',
  src: props.src
}))`
	margin: 0 10px 0 0;
`;

const Autocomplete = ({
  value,
  data,
  label,
  placeholder,
  multiple,
  disabled,
  onOpen,
  onClose,
  onChange,
  ...rest
}) => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, label && /*#__PURE__*/_react.default.createElement(Label, null, label), /*#__PURE__*/_react.default.createElement(_lab.Autocomplete, {
    value: value,
    disabled: disabled,
    multiple: multiple,
    ListboxProps: { ...rest
    },
    onChange: (e, v) => {
      // eslint-disable-next-line no-unused-expressions
      onChange && onChange(v);
    },
    onOpen: () => {
      // eslint-disable-next-line no-unused-expressions
      onOpen && onOpen();
      setIsOpen(true);
    },
    onClose: () => {
      // eslint-disable-next-line no-unused-expressions
      onClose && onClose();
      setIsOpen(false);
    },
    className: classes.autocomplete,
    closeIcon: /*#__PURE__*/_react.default.createElement(_Close.default, {
      width: "13px"
    }),
    popupIcon: /*#__PURE__*/_react.default.createElement(_Chevron.default, {
      width: "18px",
      fillColor: isOpen ? _constants.colours.primary : _constants.colours.font
    }),
    renderOption: option => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, option.icon && /*#__PURE__*/_react.default.createElement(AutocompleteIcon, {
      src: option.icon
    }), option.title),
    size: "small",
    options: data,
    getOptionLabel: ({
      title
    }) => title,
    renderInput: params => /*#__PURE__*/_react.default.createElement(_TextField.default, _extends({}, params, {
      placeholder: placeholder,
      label: "",
      variant: "outlined"
    }))
  }));
};

Autocomplete.propTypes = {
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string,
    icon: _propTypes.default.string
  })),
  onOpen: _propTypes.default.func,
  onClose: _propTypes.default.func,
  onChange: _propTypes.default.func,
  label: _propTypes.default.string,
  multiple: _propTypes.default.bool
};
Autocomplete.defaultProps = {
  data: [],
  label: '',
  multiple: false,
  onOpen: () => {},
  onClose: () => {},
  onChange: () => {}
};
var _default = Autocomplete;
exports.default = _default;